import { AccordionText } from '@boi/core/lib';
import React from 'react';

import { commonFormStylesIdentifier } from '../../constants';

const className = 'c-MarketingConsentPage';
const AnalyzeTransaction = () => {
  return (
    <>
      <AccordionText
        label="Show me examples"
        labelColor="inherit"
        openLabel="Show less"
        underline
        inverted
      >
        <div
          className={`${className}__readMoreContent ${commonFormStylesIdentifier}__infoText`}
        >
          <div className={`${className}--spaceBellow`}>
            <span>
              If you are a customer who makes regular monthly deposits, we may send you information on savings or investment products.
            </span>
          </div>
        </div>
      </AccordionText>
    </>
  );
};

export default AnalyzeTransaction;
